module.exports = __webpack_public_path__ + "media/images/users/girl-80f294540796c11a9bbcf6caf29d6793.svg";